import Vue from "vue";
import axios from "axios";
import moment from "moment";
import {MODELS} from "../resources";

moment.locale("pt-BR");

//LOTE ALOCADO
export const ActLoadListaLoteAlocado = ({commit}, cdPlanejamentoAlojamento) => {
	return axios.get(`/planejamento-alojamento-alocado/?cdPlanejamentoAlojamento=${cdPlanejamentoAlojamento}`)
			.then(res => {
				if (!res.data) return
				if (!res.data[0].data) return

				commit('mtChangeListaLoteAlocado', res.data[0].data)
			})
			.catch(error => {
				commit("setSnack", {type: "error", msg: error}, { root: true })
			})
};

export const ActSaveListaLotesAlocados = ({state, commit}, idPlanejamentoAlojamento) => {
	return axios.put(`/planejamento-alojamento-alocado/${idPlanejamentoAlojamento}/editar-alocados/`, state.listaLotesAlocados)
			.then(res => {
				if (!res.data) return
				if (!res.data[0].data) return

				// Deveria avisar que salvou?
				// commit("setSnack", {type: "success", msg: "Alterações salvas!"}, { root: true })
			})
			.catch(error => {
				commit("setSnack", {type: "error", msg: error}, { root: true })
			})
};

// ACTIONS LOTE ALOCADO
export const ActRemoveLoteAlocado = ({ commit, state }, alocado) => {
  const idxAlocado = state.listaLotesAlocados.findIndex( lote => lote.idPlanejamentoAlojamentoAlocado === alocado.idPlanejamentoAlojamentoAlocado)
  if (idxAlocado > -1) {
	  axios.delete(`/planejamento-alojamento-alocado/${alocado.idPlanejamentoAlojamentoAlocado}`, alocado)
			.then(res => {
				if (!res.data) return
				if (!res.data[0].data) return

				commit("mtRemoveLoteAlocado", res.data[0].data.idPlanejamentoAlojamentoAlocado)
			})
			.catch(error => {
				commit("setSnack", {type: "error", msg: error}, { root: true })
			})
  }
};
export const ActColarLoteAlocado = ({commit, state, dispatch}, selectedDay) => {
	const loteParaAlocar = new MODELS.LOTE_ALOCADO.constructor(
						selectedDay.cdLoteProducaoCreche,
						selectedDay.cdCrecheSemLote,
						state.cacheLoteAlocado.cdPlanejamentoAlojamentoLoteDestino,
						selectedDay.stDiaAlocado,
						null,
						selectedDay.dtAlocado,
						state.cacheLoteAlocado.cdPlanejamentoAlojamento,
						null
				)

	axios.put(`/planejamento-alojamento-alocado/${loteParaAlocar.cdPlanejamentoAlojamento}/editar-alocados/`,
			[...state.listaLotesAlocados, loteParaAlocar])
			.then(res => {
				if (!res.data) return
				if (!res.data[0].data) return

				commit('mtChangeListaLoteAlocado', res.data[0].data ? res.data[0].data : [])

				if (state.cacheLoteAlocado.sgAcaoLoteAlocado === 'RE') {
					const idx = state.listaLotesAlocados.findIndex(lote => {
						return lote.idPlanejamentoAlojamentoAlocado === state.cacheLoteAlocado.idPlanejamentoAlojamentoAlocado
					})
					if (idx > -1) {
						dispatch('ActRemoveLoteAlocado', state.listaLotesAlocados[idx])
					}
				}

				commit('mtCancelaCopiarRecortarLoteAlocado')
			})
			.catch(error => {
				commit("setSnack", {type: "error", msg: error}, {root: true})
				commit('mtCancelaCopiarRecortarLoteAlocado')
			})
};


//PRE ALOJAMENTO
export const ActLoadListaLoteDestinoPreAlojamento = ({commit}, cdPlanejamentoAlojamento) => {
	commit('mtAlterarLoadingLoteDestinoPreAlojamento', true)
	return axios.get(`/planejamento-alojamento-lote-destino/?cdPlanejamentoAlojamento=${cdPlanejamentoAlojamento}`)
			.then(res => {
				if (!res.data) return
				if (!res.data[0].data[0]) {
					commit('mtChangeListaLoteDestinoPreAlojamento', [])
					commit('mtChangeQtTotalDiasVazio', 0)
					return
				}

				commit('mtChangeListaLoteDestinoPreAlojamento', res.data[0].data[0].lotesDestino)
				commit('mtChangeQtTotalDiasVazio', res.data[0].data[0].qtTotalDiasVazio)
			})
			.catch(error => {
				commit("setSnack", {type: "error", msg: error}, { root: true })
			})
			.finally(() => commit('mtAlterarLoadingLoteDestinoPreAlojamento', false))
};

//ALOJAMENTO
export const ActLoadListaLoteDestinoAlojamento = ({commit}, {cdPlanejamentoAlojamento, listaCdEstabelecimentoCreche}) => {
	commit('mtAlterarLoadingLoteDestinoPreAlojamento', true)
	return axios.get(`/planejamento-alojamento-lote-destino/?cdPlanejamentoAlojamento=${cdPlanejamentoAlojamento}&cdEstabelecimentosCreches=${listaCdEstabelecimentoCreche}`)
			.then(res => {
				if (!res.data) return
				if (!res.data[0].data) return

				commit('mtChangeListaLoteDestinoAlojamento', res.data[0].data)
			})
			.catch(error => {
				commit("setSnack", {type: "error", msg: error}, { root: true })
			})
			.finally(() => commit('mtAlterarLoadingLoteDestinoPreAlojamento', false))
};
